import React from "react";

const CourseCard = ({ course }) => {
	return (
		<div className="w-80 h-96 border rounded-lg p-3 hover:shadow-2xl shadow-md relative">
			<div className="w-full h-full relative overflow-hidden">
				<div className="w-full h-[50%] overflow-hidden rounded-lg">
					<img
						alt="course"
						src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80"
						className="w-full h-full object-center object-cover "
					/>
				</div>
				<h3 className="text-lg font-semibold">{course.name}</h3>
				<p className="opacity-70 line-clamp-5 text-sm">
					{course.description}
				</p>
				<button className="bg-orange-600 rounded-full px-4 py-1 text-white font-medium absolute bottom-1 left-1">
					Start Watching
				</button>
				<div className="w-[50%] h-[50%] bg-gray-400 opacity-50 rounded-s-full rotate-45 absolute -bottom-16 -right-10"></div>
				<div className="w-[25%] h-[25%] bg-gray-400 opacity-50 rounded-full rotate-45 absolute top-[50%] -right-10"></div>
			</div>
		</div>
	);
};

export default CourseCard;
